import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery } from 'react-query'
import { informalFeedbackRequestsKeys } from './informalFeedbackRequestsKeys'
import { InformalFeedbackRequestsService } from 'api/services/InformalFeedbackRequestsService'
import { useSelector, useStore } from 'react-redux'
import { RootState } from 'types'
import isEqual from 'lodash/isEqual'

export const useInformalFeedbackRequest = (id: number) => {
  const store = useStore()
  const request = useSelector(({ informalFeedbackRequests }: RootState) => informalFeedbackRequests[id], isEqual)

  return useQuery(
    informalFeedbackRequestsKeys.detail(id),
    async () => {
      const res = await InformalFeedbackRequestsService.show(store, id)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      initialData: () => {
        if (!request) return

        return {
          informal_feedback_request: request,
        }
      },
      refetchOnWindowFocus: false,
    },
  )
}
